/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  SimpleERC20Token,
  SimpleERC20TokenInterface,
} from "../SimpleERC20Token";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "burnFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class SimpleERC20Token__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<SimpleERC20Token> {
    return super.deploy(overrides || {}) as Promise<SimpleERC20Token>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): SimpleERC20Token {
    return super.attach(address) as SimpleERC20Token;
  }
  connect(signer: Signer): SimpleERC20Token__factory {
    return super.connect(signer) as SimpleERC20Token__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): SimpleERC20TokenInterface {
    return new utils.Interface(_abi) as SimpleERC20TokenInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): SimpleERC20Token {
    return new Contract(address, _abi, signerOrProvider) as SimpleERC20Token;
  }
}
